import React, { useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import StringList from 'src/components/StringList/StringList';
import StringDetailView from 'src/views/StringDetailView';
import SourceReview from 'src/views/SourceReview';
import LandingPageView from 'src/views/LandingPageView/LandingPageView';
import WhereIsMyStringView from 'src/views/WhereIsMyStringView';
import { loadPreferences } from 'src/api/preferencesClient';
import TargetSearch from './TargetSearch/TargetSearch';
import { I18nFamilyQueryResultProvider } from './common/provider/QueryResultProvider';
import MessageGroupDetailView from 'src/views/SourceReview/MessageGroupDetailView';

//persist query params when redirected back from auth

const Routes: React.FC = () => {
  const [hasPersona, setHasPersona] = useState(!!loadPreferences()?.persona);
  const onInitialSetupDone = () => {
    setHasPersona(true);
  };
  const landingPage = {
    pathname: '/landing',
    state: { redirected: true },
  };
  return (
    <Switch>
      <Route path="/landing">
        <LandingPageView onSetupDone={onInitialSetupDone} />
      </Route>
      <Route path="/strings/:id">
        {hasPersona ? <StringDetailView /> : <Redirect to={landingPage} />}
      </Route>
      <Route path="/sourceReview/messageGroup/:name">
        <MessageGroupDetailView />
      </Route>
      <Route path="/sourceReview">
        <SourceReview id="lui-source-review" />
      </Route>
      <Route path="/translations">
        {hasPersona ? (
          <I18nFamilyQueryResultProvider>
            <TargetSearch id="lui-target-search" />
          </I18nFamilyQueryResultProvider>
        ) : (
          <Redirect to={landingPage} />
        )}
      </Route>
      <Route path="/wims">
        <WhereIsMyStringView />
      </Route>
      <Route path="/">
        {hasPersona ? (
          <I18nFamilyQueryResultProvider>
            <StringList id="lui-string-list" />
          </I18nFamilyQueryResultProvider>
        ) : (
          <Redirect to={landingPage} />
        )}
      </Route>
    </Switch>
  );
};

export default Routes;
